<div class="antialiased">
    <!-- Navbar -->
    <app-header></app-header>
    <!-- Sidebar -->
    <app-side-bar></app-side-bar>
    <main class="p-4 md:ml-72 h-auto pt-20">
        <router-outlet></router-outlet>
    </main>
</div>